import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { TiLocationOutline } from 'react-icons/ti';
import styles from './style.scss';

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
};

function FullAddress({ address }) {
  return <div className={styles.fullAddress}>{address.map(a => <div>{a}</div>)}</div>;
}

FullAddress.propTypes = {
  address: PropTypes.object,
};

function GoogleLocation({ event }) {
  if (!event.get('venue')) {
    return <span />;
  }
  const location = event.get('venue', '');
  return (
    <div style={{ display: 'flex', marginRight: 10 }}>
      <TiLocationOutline size={25} style={{ marginRight: 5 }} />
      <div className="location">{location}</div>{' '}
    </div>
  );
}

GoogleLocation.propTypes = propTypes;

export default GoogleLocation;



// WEBPACK FOOTER //
// ./src/widget/event_components/google_location.js